import { getAuthenticatedApiClient } from '../api-client';
import { useMutation } from 'react-query';

const deleteImages = (ids: number[]) =>
  getAuthenticatedApiClient()
    .deleteImageGalleryImages({ iImageGalleryDeleteManyRequest: { ids } })
    .then((res) => res.data);

export const useDeleteImages = () => useMutation('delete-images', deleteImages);
